import messages from "@/i18n/messages";
import "@appkit4/react-components/dist/styles/appkit4-react.min.css";
import "@appkit4/styles/themes/appkit.orange.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import { QueryClient, QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router-dom";
// keep this order - globals, then router which include local styles
import "./styles/globals.scss";
import router from "./router";

const LOCALE = "en";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <IntlProvider locale={LOCALE} defaultLocale="en" messages={messages[LOCALE]}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </IntlProvider>
  </React.StrictMode>
);
